import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { DealStatusColors } from './icon-color.const';

@Component({
  selector: 'roma-icon-color',
  templateUrl: './icon-color.component.html',
  styleUrls: ['./icon-color.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconColorComponent implements OnInit, AfterViewInit {
  @HostBinding('style.color')
  colorText: string;

  @HostBinding('style.backgroundColor')
  backgroundColor: string;

  @Input()
  set color(value: string) {
    this._color = value;
    this.resolveSelectedColor();
    this.resolveBindingColor();
  }

  get color() {
    return this._color;
  }

  selectedColor!: { lightColor: string; darkColor: string };

  private _color!: string;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  private resolveSelectedColor(): void {
    const colors = DealStatusColors;

    const selectedDefaultColor = () => {
      this.selectedColor = colors[0];
    };

    if (!this.color) {
      selectedDefaultColor();
    }

    const color = colors.find(
      (color) => color.lightColor.toLowerCase() === this.color?.toLowerCase()
    );

    if (color) {
      this.selectedColor = color;
    } else {
      selectedDefaultColor();
    }

    this.draw();
  }

  private resolveBindingColor() {
    if (this.selectedColor) {
      this.colorText = this.selectedColor.darkColor;
      this.backgroundColor = this.selectedColor.lightColor;
      this.draw();
    }
  }

  private draw(): void {
    this.cdRef.detectChanges();
  }
}
